// 折线图
export const baseLineOption = {
    title: {
        top: 0,
        left: 0,
        textStyle: {
            color: '#303133',
            fontSize: 14
        }
    },
    tooltip: {
        trigger: 'axis'
    },
    grid: {
        top: '15%',
        left: 0,
        right: 0,
        containLabel: true
    },
    yAxis: {
        type: 'value',
        axisLine: {
            show: false
        },
        axisTick: {
            show: false
        }
    }
};

// 柱状图
export const baseBarOption = {
    title: {
        top: 0,
        left: 0,
        textStyle: {
            color: '#303133',
            fontSize: 14
        }
    },
    // color: ['#2F9EFF'],
    tooltip: {
        trigger: 'axis'
    },
    grid: {
        top: '10%',
        left: 0,
        right: 0,
        containLabel: true
    },
    yAxis: {
        type: 'value',
        axisLine: {
            show: false
        },
        axisTick: {
            show: false
        }
    }
};

// 柱状叠加图
export const basePileBarOption = {
    title: {
        top: 0,
        left: 0,
        textStyle: {
            color: '#303133',
            fontSize: 14
        }
    },
    legend: {
        left: 6,
        top: '11%',
        itemWidth: 8,
        itemHeight: 8
    },
    tooltip: {
        trigger: 'axis',
        axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
        }
    },
    grid: {
        top: '22%',
        left: 0,
        right: 0,
        containLabel: true
    },
    yAxis: {
        type: 'value',
        axisLine: {
            show: false
        },
        axisTick: {
            show: false
        }
    }
};

// 柱状叠加图series里面的label通用配置
export const PileLabel = {
    normal: {
        show: true,
        position: 'insideRight'
    }
};
